/*!
 * Adapted from jQuery UI core
 *
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/ui-core/
 *
 * NOTE: pulled from react-modal - EP
 * https://github.com/reactjs/react-modal/blob/75a1aa360c25208b4f08648863cbaa8d737ef9fe/lib/helpers/tabbable.js
 */

function hidden(el: HTMLElement): boolean {
  return (
    (el.offsetWidth <= 0 && el.offsetHeight <= 0) || el.style.display === 'none'
  )
}

function visible(element: HTMLElement): boolean {
  let ourElement = element

  while (ourElement) {
    if (ourElement === document.body) {
      break
    }
    if (hidden(ourElement)) {
      return false
    }

    ourElement = ourElement.parentNode as HTMLElement
  }

  return true
}

function findTabbableDescendants(element: HTMLElement): HTMLElement[] {
  return [].slice
    .call(
      element.querySelectorAll(
        'a[href], button, input, textarea, select, details,[tabindex]:not([tabindex="-1"])',
      ),
      0,
    )
    .filter(visible)
}

export default findTabbableDescendants
